import React from 'react';
import { Box } from '@material-ui/core';
import { Toolbar } from '../../../../ui-kit';
import WarehouseSwitch from './WarehouseSwitch';

interface WarehouseToolbarProps {
    endAdorment?: JSX.Element;
}

const WarehouseToolbar = ({ endAdorment }: WarehouseToolbarProps) => {
    let content = <WarehouseSwitch />;
    if (endAdorment) {
        content = (
            <Box style={{ width: '100%' }} display="flex" justifyContent="space-between" alignItems="center">
                {content}
                {endAdorment}
            </Box>
        );
    }

    return (
        <Toolbar>
            {content}
        </Toolbar>
    );
};

export default WarehouseToolbar;
